import { render, staticRenderFns } from "./comment-content.vue?vue&type=template&id=2c5ca314&"
import script from "./comment-content.vue?vue&type=script&lang=js&"
export * from "./comment-content.vue?vue&type=script&lang=js&"
import style0 from "./comment-content.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports